export const CREATE_ACCOUNT = 'recurly';
export const GET_PAGES = 'pages';
